import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import config from '../config';
import { headers } from "../token";
const server_backend = config.API_URL;



const TransactionsList = () => {

    const [Transactions, setTransactios] = useState([]);

    useEffect(() => {

        const GetTransactios = async () => {

            try {

                const response = await axios.get(`${server_backend}/system/transactions_status/list`, headers);
                setTransactios(response.data.RES_RESULT);
                console.log(response.data.RES_RESULT)
            } catch (error) {
                console.log(error)
            }

        }
        GetTransactios()

    }, [0]);


    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0">Transactions List</h4>

                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><a href="javascript: void(0);">Transactions</a></li>
                                    <li className="breadcrumb-item active">Transactions List</li>
                                </ol>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <div className="card" id="tasksList">
                            <div className="card-header border-0">
                                <div className="d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">All Transactions</h5>
                                    <div className="flex-shrink-0">
                                        <Link className="btn btn-danger add-btn" to="/create-Transactions">
                                            <i className="ri-add-line align-bottom me-1"></i> Create Transactions
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                <form>
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <div className="search-box">
                                                <input type="text" className="form-control search bg-light border-light" placeholder="Search for tasks or something..." />
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </div>
                                        <div className="col-xxl-3 col-sm-4">
                                            <input type="text" className="form-control bg-light border-light" id="demo-datepicker" data-provider="flatpickr" data-date-format="d M, Y" data-range-date="true" placeholder="Select date range" />
                                        </div>
                                        <div className="col-xxl-3 col-sm-4">
                                            <div className="input-light">
                                                <select className="form-control" data-choices data-choices-search-false name="choices-single-default" id="idStatus">
                                                    <option value="">Status</option>
                                                    <option value="all" selected>All</option>
                                                    <option value="New">New</option>
                                                    <option value="Pending">Pending</option>
                                                    <option value="Inprogress">Inprogress</option>
                                                    <option value="Completed">Completed</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xxl-1 col-sm-4">
                                            <button type="button" className="btn btn-primary w-100" >
                                                <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive table-card mb-4">
                                    <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                        <thead className="table-light text-muted">
                                            <tr>
                                                <th scope="col" style={{ width: "40px" }}>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" id="checkAll" value="option" />
                                                    </div>
                                                </th>
                                                <th className="sort" data-sort="status">Status</th>
                                                <th className="sort" data-sort="priority">Priority</th>
                                            </tr>
                                        </thead>
                                        <tbody className="list form-check-all">
                                            {Transactions.map((TransactionsR) => (
                                                <tr>
                                                    <th scope="row">
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="checkbox" name="chk_child" value="option1" />
                                                        </div>
                                                    </th>
                                                    <td className="id">
                                                        <a href="apps-tasks-details.html" className="fw-medium link-primary">{TransactionsR.est_ID}</a>
                                                    </td>
                                                    <td className="priority">
                                                        <span className="badge bg-success text-uppercase">{TransactionsR.name}</span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="noresult" style={{ display: "none" }}>
                                        <div className="text-center">
                                            <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#121331,secondary:#08a88a" style={{ width: "75px", height: "75px" }}></lord-icon>
                                            <h5 className="mt-2">Sorry! No Result Found</h5>
                                            <p className="text-muted mb-0">We've searched more than 200k+ tasks We did not find any tasks for you search.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end mt-2">
                                    <div className="pagination-wrap hstack gap-2">
                                        <a className="page-item pagination-prev disabled" href="#">
                                            Previous
                                        </a>
                                        <ul className="pagination listjs-pagination mb-0"></ul>
                                        <a className="page-item pagination-next" href="#">
                                            Next
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade flip" id="deleteOrder" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body p-5 text-center">
                                <lord-icon
                                    src="https://cdn.lordicon.com/gsqxdxog.json"
                                    trigger="loop"
                                    colors="primary:#405189,secondary:#f06548"
                                    style={{ width: '90px', height: '90px' }}
                                />
                                <div className="mt-4 text-center">
                                    <h4>You are about to delete a task?</h4>
                                    <p className="text-muted fs-14 mb-4">
                                        Deleting your task will remove all of your information from our database.
                                    </p>
                                    <div className="hstack gap-2 justify-content-center remove">
                                        <button
                                            className="btn btn-link btn-ghost-success fw-medium text-decoration-none"
                                            data-bs-dismiss="modal"
                                        >
                                            <i className="ri-close-line me-1 align-middle"></i> Close
                                        </button>
                                        <button className="btn btn-danger" id="delete-record">Yes, Delete It</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*end delete modal */}

                <div className="modal fade zoomIn" id="showModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content border-0">
                            <div className="modal-header p-3 bg-soft-info">
                                <h5 className="modal-title" id="exampleModalLabel">Create Task</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"></button>
                            </div>
                            <form action="">
                                <div className="modal-body">
                                    <input type="hidden" id="tasksId" />
                                    <div className="row g-3">
                                        <div className="col-lg-12">
                                            <label htmlFor="projectName-field" className="form-label">Project Name</label>
                                            <input type="text" id="projectName-field" className="form-control" placeholder="Project name" required />
                                        </div>
                                        {/*end col*/}
                                        <div className="col-lg-12">
                                            <label htmlFor="tasksTitle-field" className="form-label">Title</label>
                                            <input type="text" id="tasksTitle-field" className="form-control" placeholder="Title" required />
                                        </div>
                                        {/*end col*/}
                                        <div className="col-lg-12">
                                            <label htmlFor="clientName-field" className="form-label">Client Name</label>
                                            <input type="text" id="clientName-field" className="form-control" placeholder="Client name" required />
                                        </div>
                                        {/*end col*/}
                                        <div className="col-lg-12">
                                            <label className="form-label">Assigned To</label>
                                            <div data-simplebar style={{ height: '95px' }}>
                                                <ul className="list-unstyled vstack gap-2 mb-0">
                                                    <li>
                                                        <div className="form-check d-flex align-items-center">
                                                            <input className="form-check-input me-3" type="checkbox" name="assignedTo[]" value="avatar-1.jpg" id="anna-adame" />
                                                            <label className="form-check-label d-flex align-items-center" htmlFor="anna-adame">
                                                                <span className="flex-shrink-0">
                                                                    <img src="assets/images/users/avatar-1.jpg" alt="" className="avatar-xxs rounded-circle" />
                                                                </span>
                                                                <span className="flex-grow-1 ms-2">Anna Adame</span>
                                                            </label>
                                                        </div>
                                                    </li>
                                                    {/* Repeat similar blocks for other users */}
                                                </ul>
                                            </div>
                                        </div>
                                        {/*end col*/}
                                        <div className="col-lg-6">
                                            <label htmlFor="duedate-field" className="form-label">Due Date</label>
                                            <input type="text" id="duedate-field" className="form-control" data-provider="flatpickr" placeholder="Due date" required />
                                        </div>
                                        {/*end col*/}
                                        <div className="col-lg-6">
                                            <label htmlFor="ticket-status" className="form-label">Status</label>
                                            <select className="form-control" data-choices data-choices-search-false id="ticket-status">
                                                <option value="">Status</option>
                                                <option value="New">New</option>
                                                <option value="Inprogress">Inprogress</option>
                                                <option value="Pending">Pending</option>
                                                <option value="Completed">Completed</option>
                                            </select>
                                        </div>
                                        {/*end col*/}
                                        <div className="col-lg-12">
                                            <label htmlFor="priority-field" className="form-label">Priority</label>
                                            <select className="form-control" data-choices data-choices-search-false id="priority-field">
                                                <option value="">Priority</option>
                                                <option value="High">High</option>
                                                <option value="Medium">Medium</option>
                                                <option value="Low">Low</option>
                                            </select>
                                        </div>
                                        {/*end col*/}
                                    </div>
                                    {/*end row*/}
                                </div>
                                <div className="modal-footer">
                                    <div className="hstack gap-2 justify-content-end">
                                        <button type="button" className="btn btn-light" id="close-modal" data-bs-dismiss="modal">Close</button>
                                        <button type="submit" className="btn btn-success" id="add-btn">Add Task</button>
                                        <button type="button" className="btn btn-success" id="edit-btn">Update Task</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )

}

export default TransactionsList;